import { InputGroup, Intent } from '@blueprintjs/core';
import { TFunction } from 'i18next';
import * as React from 'react';
import { Field } from 'react-final-form';

import useClientTranslations from '../../../../hooks/useClientTranslations';
import { TractableFormGroup } from './Shared';

const required = (field: string, t: TFunction) => (value: any) => {
	if (!value) {
		return t('{{field}} is required', { field });
	}

	return undefined;
};

const Model: React.FC = () => {
	const { t } = useClientTranslations();

	return (
		<Field name="model" validate={required(t('Model'), t)}>
			{({ input, meta }) => (
				<TractableFormGroup
					label={t('Model')}
					inline
					intent={Intent.DANGER}
					helperText={
						meta.invalid && meta.touched && (t(meta.error) || (!meta.dirtySinceLastSubmit && t(meta.submitError)))
					}
				>
					<InputGroup {...input} placeholder={t('ModelExmaple')} />
				</TractableFormGroup>
			)}
		</Field>
	);
};

export { Model };
